import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(1.25, 1.5),
		background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.06)' : theme.palette.grey[100],
		borderRadius: 6,
	},
	label: {
		fontSize: 9,
		fontWeight: 700,
		letterSpacing: 0.6,
		textTransform: 'uppercase',
		color: theme.palette.text.secondary,
	},
	value: { fontSize: 18, fontWeight: 700, lineHeight: 1.1 },
	delta: { fontSize: 10, marginTop: 2 },
	up: { color: theme.palette.success.main, fontWeight: 600 },
	down: { color: theme.palette.error.main, fontWeight: 600 },
	warn: { color: theme.palette.warning.main, fontWeight: 600 },
	flat: { color: theme.palette.text.disabled },
	caption: { fontSize: 10, marginTop: 2, color: theme.palette.text.disabled },
}));

export default function KpiStat({ label, value, delta, deltaLabel, dir = 'flat', warn = false, caption }) {
	const classes = useStyles();
	const dirClass = warn ? classes.warn : classes[dir] || classes.flat;
	return (
		<div className={classes.root}>
			<Typography className={classes.label}>{label}</Typography>
			<Typography className={classes.value}>{value}</Typography>
			{delta !== null && delta !== undefined && (
				<Typography className={classes.delta}>
					<span className={dirClass}>{delta}</span> {deltaLabel}
				</Typography>
			)}
			{(delta === null || delta === undefined) && caption && (
				<Typography className={classes.caption}>{caption}</Typography>
			)}
		</div>
	);
}
